import { render, staticRenderFns } from "./AuthBar.vue?vue&type=template&id=3fbad55e&scoped=true"
import script from "./AuthBar.vue?vue&type=script&lang=js"
export * from "./AuthBar.vue?vue&type=script&lang=js"
import style0 from "./AuthBar.vue?vue&type=style&index=0&id=3fbad55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbad55e",
  null
  
)

export default component.exports